import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Sprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import ACTIVE_PLAYER_HALO_IMAGE_URL from '../../../assets/active-player-halo.png';
import { useAppSelector } from '../../../redux/store';
import { getBaseAvatarScaleFactor } from '../../../utils/avatarUtils';
import { isTestEnvironment } from '../../../utils/utils';
const SCALE_FACTOR = 1.1;
export const ActivePlayerHaloContainer = ({ seatIndex }) => {
    const isSelectingSideBetTarget = useAppSelector((state) => state.sideBets.selectSideBetTargetStartTimestampMs !== undefined);
    const isPlayerIn = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.isIn);
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    const texture = useMemo(() => PIXI.Texture.from(ACTIVE_PLAYER_HALO_IMAGE_URL), []);
    if (isSelectingSideBetTarget) {
        return null;
    }
    if (!isPlayerIn) {
        return null;
    }
    const scale = SCALE_FACTOR * getBaseAvatarScaleFactor(texture.width, texture.height, bounds.w, bounds.h);
    return (_jsx(Container, { "pixi-data": isTestEnvironment() ? { type: 'active-player-halo', seatIndex } : null, scale: scale, x: bounds.x, y: bounds.y, alpha: 0.6, children: _jsx(Sprite, { texture: texture, x: Math.round(-texture.width / 2), y: Math.round(-texture.height / 2), blendMode: PIXI.BLEND_MODES.ADD }) }));
};
